import { WALK_IN_SOURCES, HOLD_MY_SPOT_VISIT_TYPE_CODE } from '../../constants';

const getVisitTypeName = ({
  sourceOfCreation,
  defaultValue,
  formatMessage,
  visitTypeCode,
}) => {
  const walkInLabel = formatMessage({ id: 'appointment.list.card.walkIn' });

  if (
    WALK_IN_SOURCES.includes(sourceOfCreation) &&
    visitTypeCode === HOLD_MY_SPOT_VISIT_TYPE_CODE
  ) {
    return walkInLabel;
  }

  return defaultValue;
};

export default getVisitTypeName;



// WEBPACK FOOTER //
// ./src/utils/appointments/getVisitTypeName.js